<template>
  <div class="home">
    <app-header ></app-header>
    <app-not-found></app-not-found>
    <app-footer></app-footer>
  </div>
</template>

<script>
// @ is an alias to /src
import HeaderCustom from "@/components/general/Header.vue";
import NotFound from "@/components/general/NotFound.vue";
import Footer from "@/components/general/Footer.vue";


export default {
name: "home",
components: {
  'app-header': HeaderCustom,
  'app-not-found': NotFound,
  'app-footer' : Footer,
  }
}   

</script>

